import _toKebabCase from 'lodash/kebabCase';

function createXmlSection({
  condition = true,
  tagName,
  content,
  indentContent = true,
}: {
  condition?: boolean;
  tagName: string;
  content: string;
  indentContent?: boolean;
}): string {
  if (!condition || !content.trim()) {
    return '';
  }

  const normalizedTagName = _toKebabCase(tagName);

  const formattedContent = indentContent
    ? content
        .split('\n')
        .map((line) => (line.trim() ? `  ${line}` : line))
        .join('\n')
    : content;

  return `

<${normalizedTagName}>
${formattedContent}
</${normalizedTagName}>`;
}

export default createXmlSection;
